import React, { useState } from 'react';
import { Zap, Crown, Rocket, CreditCard } from 'lucide-react';
import { PlanCard, GlassCard } from '../design-system/components';
import './Plans.css';
import './AnimatedButtons.css';

function Plans() {
  const [billingCycle, setBillingCycle] = useState('monthly');
  const [currentPlan] = useState('free');

  const plans = [
    {
      id: 'free',
      name: 'Gratuito',
      icon: Zap,
      price: { monthly: 0, yearly: 0 },
      description: 'Para começar a criar conteúdo',
      features: [
        '500 créditos de energia/mês',
        'Até 10 posts por mês',
        '2 vídeos por mês',
        'Templates básicos',
        'Suporte por email'
      ],
      limitations: [
        'Sem API de integração',
        'Sem agendamento',
        'Marca d\'água nos vídeos'
      ],
      cta: 'Plano Atual',
      popular: false
    },
    {
      id: 'pro',
      name: 'Profissional',
      icon: Crown,
      price: { monthly: 97, yearly: 970 },
      description: 'Para criadores e pequenas empresas',
      features: [
        '5.000 créditos de energia/mês',
        'Posts ilimitados',
        '50 vídeos por mês',
        'Todos os templates',
        'Agendamento de posts',
        'Análise de performance',
        'Integração com redes sociais',
        'Suporte prioritário',
        'Sem marca d\'água'
      ],
      limitations: [],
      cta: 'Assinar Agora',
      popular: true
    },
    {
      id: 'enterprise',
      name: 'Empresarial',
      icon: Rocket,
      price: { monthly: 297, yearly: 2970 },
      description: 'Para agências e grandes empresas',
      features: [
        'Créditos ilimitados',
        'Tudo ilimitado',
        'Vídeos ilimitados',
        'Templates personalizados',
        'API completa',
        'Múltiplas marcas',
        '10+ usuários',
        'Relatórios avançados',
        'Suporte dedicado 24/7',
        'Treinamento personalizado',
        'White label'
      ],
      limitations: [],
      cta: 'Falar com Vendas',
      popular: false
    }
  ];

  const handleUpgrade = (planId) => {
    if (planId === currentPlan) return;
    
    if (planId === 'enterprise') {
      alert('Em breve você será redirecionado para falar com nossa equipe de vendas!');
      return;
    }
    
    alert(`Você será redirecionado para o pagamento do plano ${plans.find(p => p.id === planId).name}!`);
  };

  return (
    <div className="plans-container">
      <div className="billing-toggle">
        <button 
          className={billingCycle === 'monthly' ? 'active' : ''}
          onClick={() => setBillingCycle('monthly')}
        >
          Mensal
        </button>
        <button 
          className={billingCycle === 'yearly' ? 'active' : ''}
          onClick={() => setBillingCycle('yearly')}
        >
          Anual
          <span className="discount-badge">Economize 17%</span>
        </button>
      </div>

      <div className="plans-grid mp-stagger">
        {plans.map(plan => {
          const price = plan.price[billingCycle];
          const isCurrentPlan = plan.id === currentPlan;
          const period = billingCycle === 'monthly' ? '/mês' : '/ano';
          
          return (
            <PlanCard
              key={plan.id}
              name={plan.name}
              price={`R$ ${price}`}
              period={period}
              features={plan.features}
              featured={plan.popular}
              energy={plan.popular}
              badge={plan.popular ? 'Mais Popular' : (isCurrentPlan ? 'Plano Atual' : undefined)}
              ctaText={isCurrentPlan ? plan.cta : plan.cta}
              onCta={() => handleUpgrade(plan.id)}
              className={isCurrentPlan ? 'current' : ''}
            />
          );
        })}
      </div>

      <section className="plans-faq mp-anim-fade-in">
        <h2 className="gradient-text">Perguntas Frequentes</h2>
        
        <GlassCard compact noHover className="faq-item">
          <h3>O que são créditos de energia?</h3>
          <p>Créditos de energia são usados para gerar conteúdo. Cada post consome 10 créditos, vídeos consomem de 50 a 160 créditos dependendo da duração.</p>
        </GlassCard>
        
        <GlassCard compact noHover className="faq-item">
          <h3>Posso cancelar a qualquer momento?</h3>
          <p>Sim! Não há fidelidade. Você pode cancelar seu plano a qualquer momento e continuar usando até o final do período pago.</p>
        </GlassCard>
        
        <GlassCard compact noHover className="faq-item">
          <h3>Como funciona o pagamento anual?</h3>
          <p>No plano anual, você paga uma vez por ano e economiza 17%. Você pode parcelar em até 12x no cartão de crédito.</p>
        </GlassCard>
        
        <GlassCard compact noHover className="faq-item">
          <h3>Posso fazer upgrade depois?</h3>
          <p>Sim! Você pode fazer upgrade ou downgrade a qualquer momento. Faremos o ajuste proporcional do valor.</p>
        </GlassCard>
      </section>

      <section className="payment-methods">
        <h3>Métodos de Pagamento Aceitos</h3>
        <div className="payment-icons">
          <CreditCard size={32} />
          <span>Cartão de Crédito</span>
          <span>•</span>
          <span>Pix</span>
          <span>•</span>
          <span>Boleto</span>
        </div>
        <p className="payment-note">Pagamento 100% seguro e criptografado</p>
      </section>
    </div>
  );
}

export default Plans;
